<template>
    <div class="clinic__vets">
        <h3 class="clinic__v-name r-title">Врачи</h3>
        <div class="c-vets">
            <div class="c-vets__filters">
                <div class="c-filter">
                    <el-select
                        filterable
                        multiple
                        class="form__select"
                        v-model="params.selectSpecialties"
                        @change="getDoctors()"
                        placeholder="Введите специальность"
                        no-match-text="Не найдено">
                        <el-option
                            v-for="item in specialties"
                            :key="item.id"
                            :label="item.speciality"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="c-filter">
                    <el-select
                        filterable
                        multiple
                        class="form__select"
                        v-model="params.appointmentTypes"
                        @change="getDoctors($event)"
                        placeholder="Тип записи">
                        <el-option
                            v-for="item in appointmentTypes"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search clinic__search">
                    <label class="search__label">
                        <input v-model="params.nameSearch" placeholder="Поиск по ФИО врача..." class="search__input r-text-input" v-on:keyup.13="getDoctors()">
                    </label>
                </div>
                <button @click="reset()" class="c-vets__reset r-button">Сбросить</button>
            </div>
            <div class="c-vets__list">
                <template v-for="doctor in doctors">
                    <div class="v-card" @click="saveFilter()">
                        <div class="v-card__intro">
                            <img :src="doctor.user.avatar" class="v-card__photo avatar" :alt="doctor.user.name">
                            <a :href="'/doctors/' + doctor.slug + typeGetParam" class="v-card__name r-link">{{ doctor.user.name }}</a>
                            <div class="v-card__caption">
                                <span>
                                   <template v-for="doctorSpec in doctor.doctor_specialties">
                                        <span>{{ doctorSpec.speciality }}</span><span>, </span>
                                    </template>
                                    <span>{{ doctor.clinic.user.name }}</span>
                                </span>
                            </div>
                            <div class="v-card__bottom" v-if="doctor.appointments_count > 0 && (!access || access === 'patient')">
                                <a :href="'/doctors/' + doctor.slug + typeGetParam" class="r-link button">Записаться</a>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '../../../admin/api/api';

    export default {
        data: () => ({
            doctors: [],
            specialties: [],
            appointmentTypes: [],
            isLoaded: false,
            params: {
                selectSpecialties: [],
                appointmentTypes: [],
                clinicId: 0,
                nameSearch: ''
            },
            all: 'Все специальности',
            access: window.laravel.access,
            typeGetParam: null
        }),
        methods: {
            getDoctors(filters) {
                this.typeGetParam = this.params.appointmentTypes  ? '?appointment-type=' + this.params.appointmentTypes .toString() : '';

                this.isLoaded = true;

                if (_.includes(filters, 'all')) {
                    this.params.appointmentTypes = _.map(this.appointmentTypes, 'id');

                    _.remove(this.params.appointmentTypes, type => type === 'all');
                }

				api.post('/api/doctor/clinic', this.params)
					.then((response) => {
					    this.doctors = response.data;
                        let filter = JSON.parse(sessionStorage.getItem('filterCheckbox'));

                        if (filter && filter['appointmentTypes']) {
                            filter['appointmentTypes']['elements'].forEach((element, key) => {
                                if (_.includes(this.params.appointmentTypes, element.id)) {
                                    element.checked = true;
                                } else {
                                    element.checked = false;
                                }
                            });
                        }
                        sessionStorage.setItem('filterCheckbox', JSON.stringify(filter));
					})
                    .finally(() => {
                        this.isLoaded = false;
                    });
            },
            reset() {
                this.params.selectSpecialties = [];
                this.params.appointmentTypes = [];
                this.params.nameSearch = '';
                this.getDoctors();
            },
            saveFilter() {
                sessionStorage.setItem('saveFilterClinic', true);
            }
        },
        mounted() {
            this.params.clinicId = window.laravel.clinicId;
            this.specialties = window.laravel.specialties;
            this.appointmentTypes = window.laravel.appointmentTypes;

            let filterCheckbox = JSON.parse(sessionStorage.getItem('filterCheckbox'));
            let filterCheckboxClinics = JSON.parse(sessionStorage.getItem('filterCheckboxClinics'));

            let firstShow = JSON.parse(sessionStorage.getItem('firstShow'));
            sessionStorage.setItem('firstShow', false);

            let saveFilterClinic = JSON.parse(sessionStorage.getItem('saveFilterClinic'));
            sessionStorage.setItem('saveFilterClinic', false);

            if (firstShow) {
                sessionStorage.setItem('filterCheckbox', JSON.stringify(filterCheckboxClinics));
                filterCheckbox = JSON.parse(sessionStorage.getItem('filterCheckbox'));
            }

            if (filterCheckbox && filterCheckbox['appointmentTypes'] && (saveFilterClinic || firstShow)) {
                filterCheckbox['appointmentTypes']['elements'].forEach((element, key) => {
                    if (element.checked) this.params.appointmentTypes.push(element.id);
                });
            }

            this.getDoctors();
        }
    }
</script>
